import { Component, Input } from "@angular/core";
import { SkeletonModule } from "primeng/skeleton";


@Component({
  selector: "app-job-skeleton",
  imports: [SkeletonModule],
  templateUrl: "./job-skeleton.component.html",
  styleUrl: "./job-skeleton.component.scss"
})


export class JobSkeletonComponent {

  @Input()
  isCMView: boolean = false;
}
